import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { en } from './en';
import { sv } from './sv';
@Injectable({ providedIn: 'root' })
export class DatepickerLocaleService {
  constructor(private translocoService: TranslocoService) {}

  getWeekdays(): string[] {
    if (this.translocoService.getActiveLang() === 'sv') {
      return sv.weekdays;
    } else if (this.translocoService.getActiveLang() === 'en') {
      return en.weekdays;
    }
  }

  getWeekdaysFull(): string[] {
    if (this.translocoService.getActiveLang() === 'sv') {
      return sv.weekdaysFull;
    } else if (this.translocoService.getActiveLang() === 'en') {
      return en.weekdays;
    }
  }

  getMonths(): string[] {
    if (this.translocoService.getActiveLang() === 'sv') {
      return sv.months;
    } else if (this.translocoService.getActiveLang() === 'en') {
      return en.months;
    }
  }
}
